import { ListView } from "@/services/list-view";
import { AlertTriangle } from "lucide-react";
import { useState } from "react";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";

interface DeleteViewModalProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    view: ListView | null;
    onDeleteConfirm: () => Promise<void>;
}

export function DeleteViewModal({ open, onOpenChange, view, onDeleteConfirm }: DeleteViewModalProps) {
    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        if (!view) return;

        setLoading(true);
        try {
            await onDeleteConfirm();
            onOpenChange(false);
        } catch (error) {
            console.error("Error deleting view:", error);
        } finally {
            setLoading(false);
        }
    };

    if (!view) return null;

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2 text-red-600">
                        <AlertTriangle className="h-5 w-5" />
                        Delete view
                    </DialogTitle>
                    <DialogDescription className="text-left">
                        Are you sure you want to delete the view "<span className="font-semibold">{view.name}</span>" ?
                        <br />
                        <br />
                        This action is irreversible and will permanently delete the view with all its filters and parameters.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={loading}>
                        Cancel
                    </Button>
                    <Button variant="destructive" onClick={handleDelete} disabled={loading}>
                        {loading ? "Deleting..." : "Delete"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
